type TConnectedTvPackagesProps = {
    length?: number,
    names?: string,
};

const ConnectedTvPackages = ({ length, names }: TConnectedTvPackagesProps) => {
    if (!length || !names) {
        return null;
    }

    if (length > 1) {
        return (
            <>
                У&nbsp;вас уже подключены ТВ-пакеты <b>{names}</b>. Если вы&nbsp;хотите
                продолжить пользоваться ими в&nbsp;составе тарифа-конструктора,
                выберите их&nbsp;ниже и&nbsp;пользуйтесь ТВ-пакетами дальше по&nbsp;новой цене. Подробнее в&nbsp;чеке.
            </>
        );
    }

    return (
        <>
            У&nbsp;вас уже подключен ТВ-пакет <b>{names}</b>. Если вы&nbsp;хотите
            продолжить пользоваться им в&nbsp;составе тарифа-конструктора,
            выберите его&nbsp;ниже и&nbsp;пользуйтесь ТВ-пакетом дальше по&nbsp;новой цене. Подробнее в&nbsp;чеке.
        </>
    );
};

export default ConnectedTvPackages;
